import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProblemSection() {
  const benefits = ['ordenar la valoración paso a paso', 'reconocer signos de alarma con más claridad', 'administrar medicación con más seguridad', 'mejorar tus registros clínicos', 'diferenciar situaciones urgentes de las que pueden esperar', 'estudiar sin sentirte perdido/a', 'conectar teoría con práctica real'];
  return <section className="py-12 md:py-20 lg:py-24 bg-white" data-id="element-324">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12" data-id="element-326">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-327">
            El diagnóstico
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-5 md:mb-6 leading-[1.05] uppercase" data-id="element-328">
            No te falta capacidad.
            <br data-id="element-329" />
            <span className="text-clinical-mid" data-id="element-330">
              Te falta{' '}
              <span className="accent-italic normal-case" data-id="element-331">sistema.</span>
            </span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="space-y-4 text-base md:text-lg text-clinical-ink leading-relaxed" data-id="element-332">
            <p data-id="element-333">
              Si hoy sentís que{' '}
              <span className="accent-italic" data-id="element-334">sabés teoría</span>, pero todavía
              no sabés cómo valorar con orden, priorizar bien o actuar con
              seguridad frente al paciente, no te falta capacidad.
            </p>
            <p data-id="element-335">
              El Mega Pack Enfermería organiza en{' '}
              <span className="accent-italic" data-id="element-336">un solo lugar</span> todo lo que
              necesitás para integrar valoración, signos vitales,
              procedimientos, red flags, medicación, registros y razonamiento
              clínico.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="max-w-4xl mx-auto bg-clinical-base rounded-3xl p-6 md:p-10 border border-clinical-line" data-id="element-337">
          <h3 className="text-xl md:text-2xl font-bold text-clinical-deep mb-6 md:mb-8 text-center" data-id="element-338">
            Con el Mega Pack <span className="accent-italic" data-id="element-339">vas a poder</span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-340">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-3 p-1.5" data-id="element-341">
                <div className="bg-white rounded-full p-1 flex-shrink-0 mt-0.5 border border-clinical-line" data-id="element-342">
                  <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-clinical-mid" strokeWidth={3} data-id="element-343" />
                </div>
                <span className="text-clinical-ink text-base md:text-lg leading-snug" data-id="element-344">
                  {benefit}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}